export enum ContactTypeEnum {
  phone = 0,
  mobile = 1,
  fax = 2,
  email = 3,
  commercialEmail = 4,
  administrativeEmail = 5,
  pec = 6,
  webSite = 7,
  facebook = 8,
  instagram = 9,
  twitter = 10,
  linkedIn = 11,
}
